module.exports = __webpack_public_path__ + "info-logo.png?4d2b06381c34d06107eace7ce11bf26b";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/info-logo.png
// module id = 9
// module chunks = 0